import {
    PragmaticActiveJackpot,
    PragmaticActiveJackpotResponse,
} from '@app/shared/models/interfaces/pragmatic-active-jackpot';

export function normalizePragmaticActiveJackpots(
    response: PragmaticActiveJackpotResponse | PragmaticActiveJackpot[] | any,
): PragmaticActiveJackpotResponse {
    const jackpots = Array.isArray(response) ? response : response?.jackpots ?? [];

    const normalizedJackpots = jackpots
        .filter((jackpot: PragmaticActiveJackpot) => jackpot)
        .map((jackpot: PragmaticActiveJackpot) => ({
            ...jackpot,
            tiers: Array.isArray(jackpot.tiers)
                ? jackpot.tiers.filter((tier) => tier).map((tier) => ({
                      ...tier,
                      tier: Number(tier.tier),
                      amount: Number(tier.amount),
                  }))
                : [],
            tiersNumber: Number(jackpot.tiersNumber ?? jackpot.tiers?.length ?? 0),
        }))
        .filter((jackpot: PragmaticActiveJackpot) => jackpot.status !== 'S');

    return {
        jackpots: normalizedJackpots,
        error: response?.error ?? '0',
        description: response?.description ?? 'OK',
    };
}
